import { actionGenerator } from '../../utils/redux/actionGenerator';
import {
  EReviewsActionTypes,
  TSetReviews,
  ISetReviewsPayload,
  ISetAnswersVisibilityPayload,
  TSetAnswersVisibility,
  TAddAnswersToReview,
  IAddAnswersToReviewPayload,
  ISetAnswersPagePayload,
  TSetAnswersPage,
  TSetReviewReactionPayload,
  TSetReviewReaction,
  TSetReviewsPagination,
} from './types';

export const setReviews: (payload: ISetReviewsPayload) => TSetReviews = actionGenerator<
  EReviewsActionTypes.SetReviews,
  ISetReviewsPayload
>(EReviewsActionTypes.SetReviews);

export const setReviewsPagination: (payload: ISetReviewsPayload) => TSetReviewsPagination = actionGenerator<
  EReviewsActionTypes.SetReviewsPage,
  ISetReviewsPayload
>(EReviewsActionTypes.SetReviewsPage);

export const setAnswersVisibility: (payload: ISetAnswersVisibilityPayload) => TSetAnswersVisibility = actionGenerator<
  EReviewsActionTypes.SetAnswersVisibility,
  ISetAnswersVisibilityPayload
>(EReviewsActionTypes.SetAnswersVisibility);

export const addAnswersToReview: (payload: IAddAnswersToReviewPayload) => TAddAnswersToReview = actionGenerator<
  EReviewsActionTypes.AddAnswersToReview,
  IAddAnswersToReviewPayload
>(EReviewsActionTypes.AddAnswersToReview);

export const setAnswersPage: (payload: ISetAnswersPagePayload) => TSetAnswersPage = actionGenerator<
  EReviewsActionTypes.SetAnswersPage,
  ISetAnswersPagePayload
>(EReviewsActionTypes.SetAnswersPage);

export const setReviewReactionAction: (payload: TSetReviewReactionPayload) => TSetReviewReaction = actionGenerator<
  EReviewsActionTypes.SetReviewReaction,
  TSetReviewReactionPayload
>(EReviewsActionTypes.SetReviewReaction);
